import { useId } from 'react'

export default function AgentWorkflowMobile() {
  const gid = useId().replace(/[^a-zA-Z0-9]/g, '')
  const grad = `grad_m_${gid}`
  const glow = `glow_m_${gid}`
  const blur = `blur_m_${gid}`
  return (
    <div className="wf-mobile">
      <svg className="wf-svg" viewBox="0 0 360 360" role="img" aria-label="Agents building value (mobile)">
        <defs>
          <linearGradient id={grad} x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="var(--brand)" />
            <stop offset="100%" stopColor="#6fb1ff" />
          </linearGradient>
          <filter id={glow} x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur stdDeviation="6" result="blur" />
            <feMerge>
              <feMergeNode in="blur" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
          <filter id={blur} x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur stdDeviation="2" />
          </filter>
        </defs>

        {/* subtle background glow */}
        <g opacity=".12">
          <ellipse cx="180" cy="40" rx="120" ry="22" fill="url(#grad_m_)" />
        </g>

        {/* vertical paths */}
        <g>
          <path className="wf-path wf-dash" d="M180 90 L180 140" stroke={`url(#${grad})`} />
          <path className="wf-path wf-dash" d="M180 180 L180 220" stroke={`url(#${grad})`} />
          <path className="wf-path wf-dash" d="M180 260 L180 300" stroke={`url(#${grad})`} />
        </g>

        {/* Input card */}
        <g className="wf-card" transform="translate(110, 50)">
          <rect rx="10" width="140" height="36" fill="var(--panel)" stroke="var(--border)" />
          <text x="70" y="24" textAnchor="middle" className="wf-label">Inputs</text>
        </g>

        {/* Agents (stacked) */}
        {[140, 200, 260].map((y, i) => (
          <g className="wf-agent" transform={`translate(180, ${y})`} key={i}>
            <circle r="16" cx="0" cy="0" className="wf-node" />
            <circle r="28" cx="0" cy="0" className="wf-pulse" />
            <text x="0" y="5" textAnchor="middle" className="wf-sigil">∫</text>
          </g>
        ))}

        {/* Value card */}
        <g className="wf-card wf-value" transform="translate(100, 300)">
          <rect rx="12" width="160" height="44" fill="var(--panel)" stroke="var(--border)" filter={`url(#${glow})`} />
          <g transform="translate(16,10)">
            <rect width="6" height="20" x="0" y="12" fill={`url(#${grad})`} opacity="0.7" />
            <rect width="6" height="26" x="12" y="6" fill={`url(#${grad})`} opacity="0.85" />
            <rect width="6" height="32" x="24" y="0" fill={`url(#${grad})`} />
            <text x="120" y="22" textAnchor="middle" className="wf-value-text">$</text>
          </g>
        </g>

        {/* gentle particles */}
        <g className="wf-particles" opacity=".8">
          {Array.from({ length: 8 }).map((_, i) => (
            <circle key={i} className={`wf-bit wf-bit-${i%5}`} cx={120 + (i*20)%120} cy={110 + (i*26)%140} r="1.8" fill={`url(#${grad})`} filter={`url(#${blur})`} />
          ))}
        </g>
      </svg>
    </div>
  )
}

